import { render, staticRenderFns } from "./TepTurnoCambiarVehiculo.vue?vue&type=template&id=53b434bf"
import script from "./TepTurnoCambiarVehiculo.vue?vue&type=script&lang=js"
export * from "./TepTurnoCambiarVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports